import { provider } from '@/provider.js'
import { handleActionError } from '../../errors'
import { providerResponseHandler } from '@/stores/helpers'

const getField = (rootState, metricId) => {
  const baseMetric = rootState.metrics.all.find(m => m.id === metricId)
  if (baseMetric) {
    const caseType = rootState.caseTypes.all.find(c => c.id === baseMetric.caseTypeId)
    if (!!baseMetric.propertyName && caseType && caseType.currentSchema) {
      for (const fieldset of caseType.currentSchema.fieldsets) {
        for (const field of fieldset.fields) {
          if (field.name===baseMetric.propertyName) {
            return field
          }
        }
      }
    }  
  }
} 

const formattingOptions = (field) => {
  let options = {}
  if (field) {
    options.currencySymbol = field.symbol
  }
  return options
}

export default {
  async addNewWidget({commit, rootState}, widget) {
    try {
      widget.scale = parseInt(widget.scale)
      const response = await provider.createWidget(widget)

      let options = {}
      if (response && !response.error && response.widget.metric.baseMetricId) {
        const field = getField(rootState, response.widget.metric.baseMetricId)
        options = formattingOptions(field)
      }

      providerResponseHandler(response, "Unexpected response creating widget.", () => {
        commit('addNewWidget', {widget: response.widget, options})
      })
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async updateWidget({ commit, rootState }, widget) {
    try {
      widget.scale = parseInt(widget.scale)
      const response = await provider.updateWidget(widget)

      let options = {}
      if (response && !response.error && response.widget.metric.baseMetricId) {
        const field = getField(rootState, response.widget.metric.baseMetricId)
        options = formattingOptions(field)
      }
      providerResponseHandler(response, "Unexpected response updating widget.", () => {
        commit('updateWidget', { widget: response.widget, options })
      })
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async deleteWidget({commit}, widget) {
    try {
      const response = await provider.deleteWidget(widget)
      providerResponseHandler(response, "Unexpected response deleting widget.", () => {
        commit('deleteWidget', widget)
      })
    } catch (error) {
      console.error(error)
      handleActionError(error, commit)
    }
  },
  async reorderWidgets({ commit, state }) {
    let ids = state.widgetsWithoutSection.map(w => w.id)
    state.dashboardSections.forEach(ds => {
      ids = ids.concat(ds.widgets.map(w => w.id))
    })
    await provider.reorderWidgets(ids)
  },
  async reloadWidgets({ commit, rootState }) {
    try {
      const response = await provider.getWidgets()
      if (response && response.currentUser && response.currentUser.account) {
        let widgetAndOptions = []
        if (response.currentUser.account.widgets) {
          widgetAndOptions = response.currentUser.account.widgets.map(widget => {
            let options = {}
            if (widget.metric.baseMetricId) {
              const field = getField(rootState, widget.metric.baseMetricId)
              options = formattingOptions(field)
            }
            return ({ widget, options })
          })

          commit("updateWidgets", widgetAndOptions)
        } else {
          commit('updateWidgets', [])
        }

        if (response.currentUser.account.dashboardSections) {
          commit("updateDashboardSections", {
            dashboardSections: response.currentUser.account.dashboardSections,
            widgetAndOptions
          })
        } else {
          commit("updateDashboardSections", [])
        }
      }
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async addNewDashboardSection({ commit }, dashboardSectionName) {
    try {
      const response = await provider.createDashboardSection(dashboardSectionName)
      if (response) {
        providerResponseHandler(response, "Unexpected response creating dashboard section.", () => {
          response.dashboardSection.widgets = []
          commit('addNewDashboardSection', response.dashboardSection)
        })
      }
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async updateDashboardSection({ commit }, { id, name }) {
    try {
      const response = await provider.updateDashboardSection(id, name)
      if (response) {
        providerResponseHandler(response, "Unexpected response when updating dashboard section.", () => {
          commit('updateDashboardSection', response.dashboardSection)
        })
      }
    } catch (error) {
      handleActionError(error, commit)
    }
  },
  async deleteDashboardSection({ commit }, id) {
    try {
      const response = await provider.deleteDashboardSection(id)
      if (response) {
        providerResponseHandler(response, "Unexpected response when deleting dashboard section.", () => {
          commit('deleteDashboardSection', id)
        })
      }
    } catch (error) {
      handleActionError(error, commit)
    }
  }
}
